import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
  Stack,
} from '@mui/material';
import InfoToolTip from 'containers/common/components/InfoToolTip';

function ContactsSkeleton() {
  const rows = 3; // Show 3 skeleton rows

  return (
    <Box>
      <Typography variant="pageTitle" mb={3}>
        Contacts
        <InfoToolTip title="Manage your contacts" />
      </Typography>

      <Paper>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Contact Information</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {[...Array(rows)].map((_, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <Skeleton variant="text" width={150} height={24} />
                  </TableCell>
                  <TableCell>
                    <Skeleton variant="text" width={200} height={24} />
                  </TableCell>
                  <TableCell>
                    <Skeleton variant="text" width={120} height={24} />
                  </TableCell>
                  <TableCell>
                    <Skeleton variant="rectangular" width={90} height={32} sx={{ borderRadius: 1 }} />
                  </TableCell>
                  <TableCell align="right" sx={{ pr: 3.5 }}>
                    <Stack direction="row" gap={1} justifyContent="flex-end">
                      <Skeleton animation="wave" variant="circular" width={20} height={20} />
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
}

export default ContactsSkeleton;
